import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { useTranslation } from 'react-i18next';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';
import type { BulkEditTasksApiRequest, BulkEditTasksResponse } from '../types';

export function useBulkEditTasks(projectId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { t } = useTranslation('tasks');
  const { toast } = useToast();

  return useMutation<BulkEditTasksResponse, Error, BulkEditTasksApiRequest>({
    mutationFn: (payload: BulkEditTasksApiRequest) => tasksService.bulkEditTasks(payload),

    onSuccess: (data) => {
      const successCount = data.results.filter((r) => r.success).length;
      const total = data.results.length;

      if (successCount === total) {
        toast.success({ title: t('bulkEdit.successToast', { count: successCount }) });
      } else {
        toast.warning({
          title: t('bulkEdit.partialSuccessToast', { success: successCount, total }),
        });
      }

      queryClient.invalidateQueries({ queryKey: TASK_KEYS.projectRoot(orgId, projectId) });
    },
  });
}
